module.exports = __webpack_public_path__ + "img/pos2_banner2.9e796ba5.png";